<div
  [ngClass]="
    vertical ? 'tabs-container-vertical' : style === 'pill' ? 'tabs-container-pill' : 'tabs-container-horizontal'
  "
>
  <div
    *ngFor="let tab of tabs; index as i"
    class="tab"
    [ngClass]="{ 'tab-selected': i === currentTabIndex }"
    role="tab"
    tabindex="0"
    (click)="onSelect(i); $event.stopPropagation()"
  >
    <span class="tab-label">
      {{ tab.labelPath | labelsProvider }}
      @if (tab.value) {
        <span class="tab-count">{{ tab.value }}</span>
      }
    </span>
    @if (tab.isBeta) {
      <span class="beta-badge">Beta</span>
    }
    <img
      class="icon-field"
      *ngIf="tab.tooltipLabelPath"
      src="assets/images/common/info.svg"
      height="16px"
      title="{{ tab.tooltipLabelPath | labelsProvider }}"
    />
    <div class="border" *ngIf="i === currentTabIndex && !vertical && style !== 'pill'"></div>
  </div>
</div>
